import { useEffect, useEffectEvent } from "react";
import type { FieldErrors, FormState, FieldValues } from "react-hook-form";
import { useSnackbar } from "../context/SnackbarContext";
import { getRHFErrorsRecursive } from "../validation";

type Props<T extends FieldValues> = {
  disabled?: boolean;
  errors: FieldErrors<T>;
  touched: FormState<T>["touchedFields"];
  submitCount: number;
};

export function useSnackbarRHFErrors<T extends FieldValues>({
  disabled,
  errors,
  touched,
  submitCount,
}: Props<T>) {
  const showSnackbar = useSnackbar();

  const showError = useEffectEvent((errors: FieldErrors<T>) => {
    if (disabled) return;

    const error = getRHFErrorsRecursive(errors, touched, submitCount)[0];

    if (error) {
      showSnackbar({
        content: error,
      });
    }
  });

  useEffect(() => {
    showError(errors);
  }, [errors]);
}
